import React from 'react';
import clsx from 'clsx';

import CheckTick from '../../../../../Icons/icons/CheckTick';
import { useCampaignDetail } from '../CampaignDetailProvider';

const CampaignSortSelect = () => {
  const { sortOrder, setSortOrder } = useCampaignDetail();

  const sortOptions = [
    { id: 'desc', name: 'Highest First' },
    { id: 'asc', name: 'Lowest First' },
  ];

  const handleSortSelect = (option) => {
    setSortOrder(option.id);
  };

  return (
    <div className="filter-select-container">
      <div className="filter-pill__options-container">
        {sortOptions.map((option) => {
          const selected = sortOrder === option.id;
          return (
            <div
              key={option.id}
              className={clsx('filter-pill__option-item', { selected })}
              onClick={() => handleSortSelect(option)}>
              <span className="filter-pill__option-item__text">{option.name}</span>
              {selected && <CheckTick color="var(--purple-p-400)" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CampaignSortSelect;
